// "Last used" on the login pages: which method this browser last signed in
// with. The method only, never the email. Set after a successful sign-in
// (registrations that sign the person in count too); connecting Google in
// settings doesn't change it. Both logout paths wipe localStorage, so they
// go through clearLocalStorageKeepingLastUsed() to keep this one entry.

export type SignInMethod = "password" | "google";

export const LAST_SIGN_IN_METHOD_KEY = "tdc.lastSignInMethod";

export function rememberSignInMethod(method: SignInMethod) {
    try {
        localStorage.setItem(LAST_SIGN_IN_METHOD_KEY, method);
    } catch {
        // Private mode can refuse storage; the label just doesn't show.
    }
}

export function lastSignInMethod(): SignInMethod | null {
    try {
        const v = localStorage.getItem(LAST_SIGN_IN_METHOD_KEY);
        return v === "password" || v === "google" ? v : null;
    } catch {
        return null;
    }
}

/** localStorage.clear(), except the "Last used" entry survives. */
export function clearLocalStorageKeepingLastUsed() {
    const kept = lastSignInMethod();
    localStorage.clear();
    if (kept) rememberSignInMethod(kept);
}
